module.exports = __webpack_public_path__ + "assets/img/teacher (36).7e17bc90.png";